import { render, staticRenderFns } from "./add-admin.vue?vue&type=template&id=43747527&scoped=true"
import script from "./add-admin.vue?vue&type=script&lang=js"
export * from "./add-admin.vue?vue&type=script&lang=js"
import style0 from "./add-admin.vue?vue&type=style&index=0&id=43747527&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43747527",
  null
  
)

export default component.exports